<template>
<div>
    <Breadcrumbs main="Admin" submain="AI Hub" title="OpenAI API Key" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                         <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label>API Key</label>
                                    <input class="form-control" type="text" placeholder="Enter api key" v-model="api.key">
                                </div>
                            </div>
                            <b-button class="ml-3" @click="createAPIKey">Update API Key</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex';
import { myHost } from '../../../../_helpers/host';
import loader from '../../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() { 
        return {
            host: myHost.host,
            api: {
                key: ""
            }
        };
    },

    computed: {
        ...mapState({
            key: state => state.key.key,
            loading: state => state.key.keyLoading,
            error: state => state.key.keyError
        })
    },

    watch: {
        key(oldValue, newValue) {
            this.api.key = this.key.openai_api_key
        }
    },

    mounted() {
        this.$store.dispatch("key/fetchAPIKey").then(() => {
            this.api.key = this.key.openai_api_key
        });
    },

    methods: {
        createAPIKey() {
            this.$store.dispatch("key/addAPIKey", {
                key: this.api.key
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
